module.exports = __webpack_public_path__ + "b8cee6f6cd34c5dc424927a92a1ee8b2.svg";